import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-point-tags',
  templateUrl: './point-tags.component.html',
  styleUrls: ['./point-tags.component.css']
})
export class PointTagsComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PointTagsComponent>, @Inject(MAT_DIALOG_DATA) public data) { }


  ngOnInit() {
  }

}
